import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/1_white-0/1_white-0"
 * Contains 6 texture(s)
 */
export class CardsFront1White0Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/1_white-0/1_white-0';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        'q-spades.png',
        'q-hearts.png',
        'q-diamonds.png',
        'q-clubs.png',
        'k-spades.png',
        'k-hearts.png'
    ] as const;
}
